export enum EligibilityStatusEnum {
  ELIGIBLE = 'ELIGIBLE',
  NON_ELIGIBLE_PJ = 'NON_ELIGIBLE_PJ',
  NON_ELIGIBLE_UNDER_AGE = 'NON_ELIGIBLE_UNDER_AGE',
}
